import React from 'react';
import { HeroIconName, SvgIcon } from '@gik/ui';
import { useBemCN } from '@gik/core/utils/bemBlock';
import noop from '@gik/core/utils/noop';
import Link from '@/components/Link';

export type CRMNavigationItem = {
  id: string;
  label: string;
  icon: HeroIconName;
  link: string;
};

export type CRMNavigationProps = {
  items: CRMNavigationItem[];
  onClick?: (item: CRMNavigationItem, index: number) => void;
};

export const CRMNavigation: React.FC<CRMNavigationProps> = ({ items, onClick = noop }) => {
  const bem = useBemCN('crm-navigation');

  return (
    <ul {...bem()}>
      {items.map((item, index) => {
        return (
          <Link key={item.id} href={item.link}>
            <a>
              <li {...bem('item')} onClick={() => onClick(item, index)}>
                <SvgIcon name={item.icon} {...bem('icon')} /> {item.label}
              </li>
            </a>
          </Link>
        );
      })}
    </ul>
  );
};
